<template>
  <div aria-hidden="true" class="el-tooltip__popper is-dark" role="tooltip"
       style="transform-origin: center bottom;z-index: 2019"
       x-placement="top">
    <div class="popper__arrow"></div>
  </div>
</template>

<script>
  export default {
    name: "IpsTooltip",
    props: {
      // visible: {
      //   type: Boolean,
      //   default: false
      // }
    },

    computed: {
      // style() {
      //   let display = this.visible ? 'block' : 'none'
      //   return {display}
      // }
    },

    methods: {
      location(node) {
        console.log(typeof node)
      },
      show(){
        console.log('enter')
      }
    }
  }
</script>

<style scoped>

</style>
